import APP_ACTIONS from '../constants/app-actions';
import OrderModel from '../services/order-model';

const initialState = {
    orders: [],
};

const orderList = (state = initialState, action) => {
    let newOrderList;
    let orderInList;

    switch (action.type) {
    case APP_ACTIONS.ADD_ORDERS:
        return { ...state, orders: action.payload.orders, ...action.payload.meta };

    case APP_ACTIONS.ADD_ORDER:
        orderInList = OrderModel.find(action.payload.order.id, state.orders);

        if (orderInList) {
            return state;
        }

        newOrderList = Object.assign([], state.orders);
        newOrderList.push(action.payload.order);
        return { ...state, orders: newOrderList, ...action.payload.meta };

    default:
        return state;
    }
};

export default orderList;



/** WEBPACK FOOTER **
 ** ./src/reducers/order-list.js
 **/